import React from 'react';
import { useRoutes } from "react-router-dom";
import routers from './config'

export default function Router() {
    return useRoutes(routers) 
}
